import { defineQuery } from 'next-sanity'
import { imageFields } from '../atoms'

export const careersQuoteCarouselBlockFields = `
  _id,
  _type,
  decorativeShape,
  quotes[]{
    quote,
    backgroundImage {
      ${imageFields}
    }
  }
`

export const CAREERS_QUOTE_CAROUSEL_BLOCK_QUERY = defineQuery(/* groq */ `
  *[_type == "careers-quote-carousel-block"][0]{
    ${careersQuoteCarouselBlockFields}
  }
`)
